import { useState } from "react";

import { usePortalStatusLinkAnzeigen } from "../../api/hooks";
import type { StatusLinkAusgabe } from "../../api/typen";
import { useToast } from "../../kontext/ToastKontext";
import { Karte, Knopf } from "../Basis";
import { StatusLinkModal } from "../StatusLinkModal";

/** Portal: Link für den Kunden anzeigen – immer derselbe, solange er aktiv ist. Ein Installateur kann
 * ihn hier nie versehentlich ersetzen oder den Kunden damit aussperren; das geht nur im Backoffice. */
export function StatusLinkKarte({ anlageId, vorhanden }: { anlageId: number; vorhanden: boolean }) {
  const anzeigen = usePortalStatusLinkAnzeigen(anlageId);
  const toast = useToast();
  const [ausgabe, setAusgabe] = useState<StatusLinkAusgabe | null>(null);

  function anzeigenKlick() {
    anzeigen.mutate(undefined, {
      onSuccess: setAusgabe,
      onError: (e) => toast.fehler(e, "Link konnte nicht geladen werden"),
    });
  }

  return (
    <Karte className="p-5">
      <h2 className="font-semibold">Link für Ihren Kunden</h2>
      <p className="mt-1 text-sm text-neutral-600">
        Damit sieht Ihr Kunde selbst, wie weit die Anmeldung ist – ohne Login, ohne Konto.
      </p>
      <Knopf variante="primaer" className="mt-3 w-full !py-3" laedt={anzeigen.isPending} onClick={anzeigenKlick}>
        {vorhanden ? "Link anzeigen" : "Link erzeugen"}
      </Knopf>
      {ausgabe && <StatusLinkModal ausgabe={ausgabe} schliessen={() => setAusgabe(null)} />}
    </Karte>
  );
}
